// extracted by mini-css-extract-plugin
export default {"card":"DashCard_card__xq-aP"};